import { CSSProperties } from "react";

export const actionButtonStyle: CSSProperties = { minWidth: 96 };
